module.exports = __webpack_public_path__ + "img/jewelleryBackground.06e0609.webp";